import { TeamLeadPermissionRole } from '@scale/shared/types/expertManagement';
import { Route, RouteProps } from 'react-router-dom';
import { NotAuthorized } from 'react-scale/components/ExpertManagement/NotAuthorized';
import { useIsCurrentUserAuthorized } from 'react-scale/components/ExpertManagement/hooks/useIsCurrentUserAuthorized';

export function PrivateRoute(
  props: RouteProps & { permissions: TeamLeadPermissionRole[] },
): JSX.Element {
  const isAuthorized = useIsCurrentUserAuthorized(props.permissions);
  return <>{isAuthorized ? <Route {...props} /> : <NotAuthorized />}</>;
}
